jsonpRcsMcWidFunction([23],{

/***/ 183:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants_index__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles__ = __webpack_require__(392);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_CalendarRow__ = __webpack_require__(310);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_shared_Label__ = __webpack_require__(199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_shared_StandingButton__ = __webpack_require__(255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__common_rcs_gaz_mc_core_FE__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__common_rcs_gaz_mc_core_FE___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__common_rcs_gaz_mc_core_FE__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var TeamCalendarWidget=function(_Component){_inherits(TeamCalendarWidget,_Component);function TeamCalendarWidget(props){_classCallCheck(this,TeamCalendarWidget);var _this=_possibleConstructorReturn(this,(TeamCalendarWidget.__proto__||Object.getPrototypeOf(TeamCalendarWidget)).call(this,props));_this.getChildContext=function(){return{breakpoints:[320,600,1024,1440]};};_this.getTeamCalendar=function(){var _this$props=_this.props,sportId=_this$props.sportId,teamId=_this$props.teamId,actions=_this$props.actions,widgetId=_this$props.widgetId;actions.getTeamCalendar(sportId,teamId,true,widgetId);};_this.resizeCallback=function(){_this.setState({isMobile:window.innerWidth<=1023});};_this.state={isMobile:false};return _this;}_createClass(TeamCalendarWidget,[{key:'componentDidMount',value:function componentDidMount(){window.addEventListener('resize',this.resizeCallback);//const interval = ConfigManager.getSportRefreshInterval(this.props.sportId) ? ConfigManager.getSportRefreshInterval(this.props.sportId) : 60000;
//this.sportTimer = setInterval(this.getTeamCalendar, interval);
this.getTeamCalendar();this.resizeCallback();}},{key:'componentWillUnmount',value:function componentWillUnmount(){window.removeEventListener('resize',this.resizeCallback);/* if (this.sportTimer) {
      clearInterval(this.sportTimer);
    }*/}},{key:'render',value:function render(){var _props=this.props,dictionary=_props.dictionary,calendars=_props.calendars,sportId=_props.sportId,widgetTitle=_props.widgetTitle,widgetId=_props.widgetId;var calendar=calendars.get(widgetId);var isMobile=this.state.isMobile;var label=widgetTitle!==null?widgetTitle:'Calendario e risultati';return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styles__["a" /* TeamCalendarWidgetWrapper */],{isMobile:isMobile},label&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_shared_Label__["a" /* default */],{label:label,color:'black',size:1.2,isTitleNarrowMedium:true,margin:'10px 0 20px'}),calendar&&calendar.get('calendar')&&calendar.getIn(['calendar',0])&&calendar.getIn(['calendar',0,'matches'])&&calendar.getIn(['calendar',0,'matches']).map(function(match,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_CalendarRow__["a" /* default */],{dictionary:dictionary,competitionId:match.get('competitionId'),isMobile:isMobile,matchRow:match,key:index,newspaper:'gazzetta'});}),calendar&&calendar.get('teamName')&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_shared_StandingButton__["a" /* default */],{color:'white',background:'buttonColor',label:'Vedi tutte',size:'1.2',margin:'26px 0 10px',linkTo:Object(__WEBPACK_IMPORTED_MODULE_8__common_rcs_gaz_mc_core_FE__["prettyTeamUrl"])(sportId,'21',"gazzetta",calendar.get('teamName'))+'calendario-risultati/'}));}}]);return TeamCalendarWidget;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);TeamCalendarWidget.childContextTypes={breakpoints:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number)};TeamCalendarWidget.propTypes={actions:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,dictionary:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,sportId:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,teamId:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,calendars:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,widgetTitle:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,widgetId:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any};/* harmony default export */ __webpack_exports__["default"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(function(state){return{dictionary:state.dictionaryReducer.dictionary,calendars:state.calendarReducer.get('calendars')};},function(dispatch){return{actions:{initDictionary:function initDictionary(){return dispatch({type:__WEBPACK_IMPORTED_MODULE_3__constants_index__["_63" /* INIT_DICTIONARY */]});},getTeamCalendar:function getTeamCalendar(sportId,teamId,isWidget,widgetId,seasonId){return dispatch({type:__WEBPACK_IMPORTED_MODULE_3__constants_index__["_48" /* GET_TEAM_CALENDAR_REQUEST */],sportId:sportId,teamId:teamId,isWidget:isWidget,widgetId:widgetId,seasonId:seasonId});}}};})(TeamCalendarWidget));

/***/ }),

/***/ 197:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/* global window */
/* eslint "no-console": "off" */

var getViewPort = function getViewPort() {
  if (typeof window !== 'undefined' && window.innerWidth) {
    return window.innerWidth;
  }
  return null;
};

var screenClasses = exports.screenClasses = ['xs', 'sm', 'md', 'lg', 'xl'];

var defaultBreakpoints = exports.defaultBreakpoints = [576, 768, 992, 1200];

var defaultContainerWidths = exports.defaultContainerWidths = [540, 750, 960, 1140];

var defaultGutterWidth = exports.defaultGutterWidth = 30;

var defaultGridColumns = exports.defaultGridColumns = 12;

var getScreenClass = exports.getScreenClass = function getScreenClass(_ref) {
  var serverSideScreenClass = _ref.serverSideScreenClass,
      breakpoints = _ref.breakpoints;

  var theBreakpoints = breakpoints && breakpoints.length ? breakpoints : defaultBreakpoints;

  var screenClass = serverSideScreenClass || 'xl';

  var viewport = getViewPort();
  if (viewport) {
    screenClass = 'xs';
    if (theBreakpoints[0] && viewport >= theBreakpoints[0]) screenClass = 'sm';
    if (theBreakpoints[1] && viewport >= theBreakpoints[1]) screenClass = 'md';
    if (theBreakpoints[2] && viewport >= theBreakpoints[2]) screenClass = 'lg';
    if (theBreakpoints[3] && viewport >= theBreakpoints[3]) screenClass = 'xl';
  }

  return screenClass;
};

/***/ }),

/***/ 198:
/***/ (function(module, exports, __webpack_require__) {

var debounce = __webpack_require__(216),
    isObject = __webpack_require__(200);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */
function throttle(func, wait, options) {
  var leading = true,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  if (isObject(options)) {
    leading = 'leading' in options ? !!options.leading : leading;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }
  return debounce(func, wait, {
    'leading': leading,
    'maxWait': wait,
    'trailing': trailing
  });
}

module.exports = throttle;


/***/ }),

/***/ 199:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(207);
var Label=function Label(_ref){var label=_ref.label,color=_ref.color,size=_ref.size,weight=_ref.weight,margin=_ref.margin,withCursor=_ref.withCursor,lineHeight=_ref.lineHeight,alignSelf=_ref.alignSelf,isTitleNarrowMedium=_ref.isTitleNarrowMedium,noAlign=_ref.noAlign,width=_ref.width,height=_ref.height,textAlignment=_ref.textAlignment,preLabel=_ref.preLabel,isCapitalize=_ref.isCapitalize,block=_ref.block,font=_ref.font,letterSpacing=_ref.letterSpacing,className=_ref.className;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* LabelWrapper */],{block:block,withCursor:withCursor,color:color,size:size,weight:weight,margin:margin,lineHeight:lineHeight,alignSelf:alignSelf,isTitleNarrowMedium:isTitleNarrowMedium,noAlign:noAlign,width:width,height:height,textAlignment:textAlignment,isCapitalize:isCapitalize,font:font,letterSpacing:letterSpacing,className:className},preLabel&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__styles__["b" /* PreLabelContainer */],null,preLabel),label);};Label.propTypes={block:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,preLabel:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,label:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,color:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,size:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,weight:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,margin:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,withCursor:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,noAlign:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,lineHeight:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,alignSelf:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,isTitleNarrowMedium:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,width:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,height:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,textAlignment:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,isCapitalize:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,font:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,letterSpacing:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,className:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string};/* harmony default export */ __webpack_exports__["a"] = (Label);

/***/ }),

/***/ 200:
/***/ (function(module, exports) {

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),

/***/ 201:
/***/ (function(module, exports, __webpack_require__) {

var freeGlobal = __webpack_require__(218);

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;


/***/ }),

/***/ 202:
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(201);

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;


/***/ }),

/***/ 204:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ScreenClassRender = exports.Visible = exports.Hidden = exports.Row = exports.Container = exports.Col = undefined;

var _Col2 = __webpack_require__(215);

var _Col3 = _interopRequireDefault(_Col2);

var _Container2 = __webpack_require__(228);

var _Container3 = _interopRequireDefault(_Container2);

var _Row2 = __webpack_require__(230);

var _Row3 = _interopRequireDefault(_Row2);

var _Hidden2 = __webpack_require__(232);

var _Hidden3 = _interopRequireDefault(_Hidden2);

var _Visible2 = __webpack_require__(234);

var _Visible3 = _interopRequireDefault(_Visible2);

var _ScreenClassRender2 = __webpack_require__(236);

var _ScreenClassRender3 = _interopRequireDefault(_ScreenClassRender2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.Col = _Col3.default; // Grid

exports.Container = _Container3.default;
exports.Row = _Row3.default;

// Utilities

exports.Hidden = _Hidden3.default;
exports.Visible = _Visible3.default;
exports.ScreenClassRender = _ScreenClassRender3.default;

/***/ }),

/***/ 205:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_lazyload__ = __webpack_require__(206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_lazyload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_lazyload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_assets_player_jpeg__ = __webpack_require__(214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_assets_player_jpeg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__utils_assets_player_jpeg__);
var flagImg='https://images2.gazzettaobjects.it/matchcenter/static/placeholder/placeholder-shield.svg';var TeamLabel=function TeamLabel(_ref){var title=_ref.title,alt=_ref.alt,label=_ref.label,color=_ref.color,size=_ref.size,weight=_ref.weight,marginLeft=_ref.marginLeft,marginRight=_ref.marginRight,marginTop=_ref.marginTop,isMatchPageInverse=_ref.isMatchPageInverse,isMatchPage=_ref.isMatchPage,withCursor=_ref.withCursor,image=_ref.image,nameteam=_ref.nameteam,font=_ref.font,isPlayer=_ref.isPlayer,isForma=_ref.isForma,isFlag=_ref.isFlag,isWorldCup=_ref.isWorldCup,reverseTitle=_ref.reverseTitle,justifyContent=_ref.justifyContent,isAColumn=_ref.isAColumn,isHeader=_ref.isHeader,width=_ref.width,marginWrapper=_ref.marginWrapper,isStripCalendar=_ref.isStripCalendar,noLogo=_ref.noLogo,textWidth=_ref.textWidth,alignment=_ref.alignment,isUpperCase=_ref.isUpperCase,whiteSpace=_ref.whiteSpace,isCorriereCalendar=_ref.isCorriereCalendar,noFavStar=_ref.noFavStar,height=_ref.height;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__styles__["c" /* TeamWrapper */],{withCursor:withCursor,justifyContent:justifyContent,isAColumn:isAColumn,marginWrapper:marginWrapper,className:'boxTeam'},isMatchPageInverse&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__styles__["b" /* TeamName */],{marginLeft:marginLeft,marginRight:marginRight,marginTop:marginTop,color:color,size:size,weight:weight,font:font,textWidth:textWidth,alignment:alignment,whiteSpace:whiteSpace,alt:alt,title:title},label),'    ',image&&!noLogo&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_lazyload___default.a,{height:'100%'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__styles__["a" /* TeamLogo */],{isPlayer:isPlayer,isForma:isForma,isFlag:isFlag,isWorldCup:isWorldCup,isMatchPage:isMatchPage,src:image,onError:function onError(e){e.target.src=isPlayer?__WEBPACK_IMPORTED_MODULE_4__utils_assets_player_jpeg___default.a:flagImg;e.target.className+=' placeholder';},reverseTitle:reverseTitle,isHeader:isHeader,width:width,height:height,className:'logoTeamHeader',isStripCalendar:isStripCalendar,isCorriereCalendar:isCorriereCalendar,noFavStar:noFavStar,alt:nameteam,title:nameteam}))/*(
        <LazyLoad>
          <TeamLogo
            isPlayer={isPlayer}
            isFlag={isFlag}
            src=""
            reverseTitle={reverseTitle}
            isHeader={isHeader}
            width={width}
            className="logoTeamHeader"
            isStripCalendar={isStripCalendar}
          />
        </LazyLoad>
      )*/,!isMatchPageInverse&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__styles__["b" /* TeamName */],{marginLeft:marginLeft,marginRight:marginRight,marginTop:marginTop,color:color,size:size,weight:weight,font:font,textWidth:textWidth,alignment:alignment,isUpperCase:isUpperCase,whiteSpace:whiteSpace,alt:alt,title:title},label));};TeamLabel.propTypes={alt:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,title:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,label:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,width:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,color:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,justifyContent:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,size:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,weight:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,marginRight:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,marginLeft:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,marginTop:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,withCursor:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,image:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,nameteam:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,font:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,isPlayer:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,isForma:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,isFlag:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,reverseTitle:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,isMatchPage:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,isMatchPageInverse:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,isAColumn:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,isHeader:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,marginWrapper:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,isStripCalendar:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,noLogo:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,textWidth:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,alignment:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,isWorldCup:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,isUpperCase:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,whiteSpace:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,isCorriereCalendar:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,noFavStar:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,height:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any};/* harmony default export */ __webpack_exports__["a"] = (TeamLabel);

/***/ }),

/***/ 206:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.forceVisible = exports.forceCheck = exports.lazyload = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(56);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _event = __webpack_require__(209);

var _scrollParent = __webpack_require__(210);

var _scrollParent2 = _interopRequireDefault(_scrollParent);

var _debounce = __webpack_require__(211);

var _debounce2 = _interopRequireDefault(_debounce);

var _throttle = __webpack_require__(212);

var _throttle2 = _interopRequireDefault(_throttle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * react-lazyload
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */


var defaultBoundingClientRect = { top: 0, right: 0, bottom: 0, left: 0, width: 0, height: 0 };
var LISTEN_FLAG = 'data-lazyload-listened';
var listeners = [];
var pending = [];

// try to handle passive events
var passiveEventSupported = false;
try {
  var opts = Object.defineProperty({}, 'passive', {
    get: function get() {
      passiveEventSupported = true;
    }
  });
  window.addEventListener('test', null, opts);
} catch (e) {}
// if they are supported, setup the optional params
// IMPORTANT: FALSE doubles as the default CAPTURE value!
var passiveEvent = passiveEventSupported ? { capture: false, passive: true } : false;

/**
 * Check if `component` is visible in overflow container `parent`
 * @param  {node} component React component
 * @param  {node} parent    component's scroll parent
 * @return {bool}
 */
var checkOverflowVisible = function checkOverflowVisible(component, parent) {
  var node = _reactDom2.default.findDOMNode(component);
  // const node = component.ref;

  var parentTop = void 0;
  var parentLeft = void 0;
  var parentHeight = void 0;
  var parentWidth = void 0;

  try {
    var _parent$getBoundingCl = parent.getBoundingClientRect();

    parentTop = _parent$getBoundingCl.top;
    parentLeft = _parent$getBoundingCl.left;
    parentHeight = _parent$getBoundingCl.height;
    parentWidth = _parent$getBoundingCl.width;
  } catch (e) {
    parentTop = defaultBoundingClientRect.top;
    parentLeft = defaultBoundingClientRect.left;
    parentHeight = defaultBoundingClientRect.height;
    parentWidth = defaultBoundingClientRect.width;
  }

  var windowInnerHeight = window.innerHeight || document.documentElement.clientHeight;
  var windowInnerWidth = window.innerWidth || document.documentElement.clientWidth;

  // calculate top and height of the intersection of the element's scrollParent and viewport
  var intersectionTop = Math.max(parentTop, 0); // intersection's top relative to viewport
  var intersectionLeft = Math.max(parentLeft, 0); // intersection's left relative to viewport
  var intersectionHeight = Math.min(windowInnerHeight, parentTop + parentHeight) - intersectionTop; // height
  var intersectionWidth = Math.min(windowInnerWidth, parentLeft + parentWidth) - intersectionLeft; // width

  // check whether the element is visible in the intersection
  var top = void 0;
  var left = void 0;
  var height = void 0;
  var width = void 0;

  try {
    var _node$getBoundingClie = node.getBoundingClientRect();

    top = _node$getBoundingClie.top;
    left = _node$getBoundingClie.left;
    height = _node$getBoundingClie.height;
    width = _node$getBoundingClie.width;
  } catch (e) {
    top = defaultBoundingClientRect.top;
    left = defaultBoundingClientRect.left;
    height = defaultBoundingClientRect.height;
    width = defaultBoundingClientRect.width;
  }

  var offsetTop = top - intersectionTop; // element's top relative to intersection
  var offsetLeft = left - intersectionLeft; // element's left relative to intersection

  var offsets = Array.isArray(component.props.offset) ? component.props.offset : [component.props.offset, component.props.offset]; // Be compatible with previous API

  return offsetTop - offsets[0] <= intersectionHeight && offsetTop + height + offsets[1] >= 0 && offsetLeft - offsets[0] <= intersectionWidth && offsetLeft + width + offsets[1] >= 0;
};

/**
 * Check if `component` is visible in document
 * @param  {node} component React component
 * @return {bool}
 */
var checkNormalVisible = function checkNormalVisible(component) {
  var node = _reactDom2.default.findDOMNode(component);
  // const node = component.ref;

  // If this element is hidden by css rules somehow, it's definitely invisible
  if (!(node.offsetWidth || node.offsetHeight || node.getClientRects().length)) return false;

  var top = void 0;
  var elementHeight = void 0;

  try {
    var _node$getBoundingClie2 = node.getBoundingClientRect();

    top = _node$getBoundingClie2.top;
    elementHeight = _node$getBoundingClie2.height;
  } catch (e) {
    top = defaultBoundingClientRect.top;
    elementHeight = defaultBoundingClientRect.height;
  }

  var windowInnerHeight = window.innerHeight || document.documentElement.clientHeight;

  var offsets = Array.isArray(component.props.offset) ? component.props.offset : [component.props.offset, component.props.offset]; // Be compatible with previous API

  return top - offsets[0] <= windowInnerHeight && top + elementHeight + offsets[1] >= 0;
};

/**
 * Detect if element is visible in viewport, if so, set `visible` state to true.
 * If `once` prop is provided true, remove component as listener after checkVisible
 *
 * @param  {React} component   React component that respond to scroll and resize
 */
var checkVisible = function checkVisible(component) {
  var node = _reactDom2.default.findDOMNode(component);
  // const node = component.ref;
  if (!(node instanceof HTMLElement)) {
    return;
  }

  var parent = (0, _scrollParent2.default)(node);
  var isOverflow = component.props.overflow && parent !== node.ownerDocument && parent !== document && parent !== document.documentElement;
  var visible = isOverflow ? checkOverflowVisible(component, parent) : checkNormalVisible(component);
  if (visible) {
    // Avoid extra render if previously is visible
    if (!component.visible) {
      if (component.props.once) {
        pending.push(component);
      }

      component.visible = true;
      component.forceUpdate();
    }
  } else if (!(component.props.once && component.visible)) {
    component.visible = false;
    if (component.props.unmountIfInvisible) {
      component.forceUpdate();
    }
  }
};

var purgePending = function purgePending() {
  pending.forEach(function (component) {
    var index = listeners.indexOf(component);
    if (index !== -1) {
      listeners.splice(index, 1);
    }
  });

  pending = [];
};

var lazyLoadHandler = function lazyLoadHandler() {
  for (var i = 0; i < listeners.length; ++i) {
    var listener = listeners[i];
    checkVisible(listener);
  }
  // Remove `once` component in listeners
  purgePending();
};

/**
 * Forces the component to display regardless of whether the element is visible in the viewport.
 */
var forceVisible = function forceVisible() {
  for (var i = 0; i < listeners.length; ++i) {
    var listener = listeners[i];
    listener.visible = true;
    listener.forceUpdate();
  }
  // Remove `once` component in listeners
  purgePending();
};

// Depending on component's props
var delayType = void 0;
var finalLazyLoadHandler = null;

var isString = function isString(string) {
  return typeof string === 'string';
};

var LazyLoad = function (_Component) {
  _inherits(LazyLoad, _Component);

  function LazyLoad(props) {
    _classCallCheck(this, LazyLoad);

    var _this = _possibleConstructorReturn(this, (LazyLoad.__proto__ || Object.getPrototypeOf(LazyLoad)).call(this, props));

    _this.visible = false;
    // this.setRef = this.setRef.bind(this);
    return _this;
  }

  // setRef(element) {
  //   if (element) {
  //     this.ref = element;
  //   }
  // }

  _createClass(LazyLoad, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      // It's unlikely to change delay type on the fly, this is mainly
      // designed for tests
      var scrollport = window;
      var scrollContainer = this.props.scrollContainer;

      if (scrollContainer) {
        if (isString(scrollContainer)) {
          scrollport = scrollport.document.querySelector(scrollContainer);
        }
      }
      var needResetFinalLazyLoadHandler = this.props.debounce !== undefined && delayType === 'throttle' || delayType === 'debounce' && this.props.debounce === undefined;

      if (needResetFinalLazyLoadHandler) {
        (0, _event.off)(scrollport, 'scroll', finalLazyLoadHandler, passiveEvent);
        (0, _event.off)(window, 'resize', finalLazyLoadHandler, passiveEvent);
        finalLazyLoadHandler = null;
      }

      if (!finalLazyLoadHandler) {
        if (this.props.debounce !== undefined) {
          finalLazyLoadHandler = (0, _debounce2.default)(lazyLoadHandler, typeof this.props.debounce === 'number' ? this.props.debounce : 300);
          delayType = 'debounce';
        } else if (this.props.throttle !== undefined) {
          finalLazyLoadHandler = (0, _throttle2.default)(lazyLoadHandler, typeof this.props.throttle === 'number' ? this.props.throttle : 300);
          delayType = 'throttle';
        } else {
          finalLazyLoadHandler = lazyLoadHandler;
        }
      }

      if (this.props.overflow) {
        var parent = (0, _scrollParent2.default)(_reactDom2.default.findDOMNode(this));
        // const parent = scrollParent(this.ref);
        if (parent && typeof parent.getAttribute === 'function') {
          var listenerCount = 1 + +parent.getAttribute(LISTEN_FLAG);
          if (listenerCount === 1) {
            parent.addEventListener('scroll', finalLazyLoadHandler, passiveEvent);
          }
          parent.setAttribute(LISTEN_FLAG, listenerCount);
        }
      } else if (listeners.length === 0 || needResetFinalLazyLoadHandler) {
        var _props = this.props,
            scroll = _props.scroll,
            resize = _props.resize;


        if (scroll) {
          (0, _event.on)(scrollport, 'scroll', finalLazyLoadHandler, passiveEvent);
        }

        if (resize) {
          (0, _event.on)(window, 'resize', finalLazyLoadHandler, passiveEvent);
        }
      }

      listeners.push(this);
      checkVisible(this);
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate() {
      return this.visible;
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.props.overflow) {
        var parent = (0, _scrollParent2.default)(_reactDom2.default.findDOMNode(this));
        // const parent = scrollParent(this.ref);
        if (parent && typeof parent.getAttribute === 'function') {
          var listenerCount = +parent.getAttribute(LISTEN_FLAG) - 1;
          if (listenerCount === 0) {
            parent.removeEventListener('scroll', finalLazyLoadHandler, passiveEvent);
            parent.removeAttribute(LISTEN_FLAG);
          } else {
            parent.setAttribute(LISTEN_FLAG, listenerCount);
          }
        }
      }

      var index = listeners.indexOf(this);
      if (index !== -1) {
        listeners.splice(index, 1);
      }

      if (listeners.length === 0 && typeof window !== 'undefined') {
        (0, _event.off)(window, 'resize', finalLazyLoadHandler, passiveEvent);
        (0, _event.off)(window, 'scroll', finalLazyLoadHandler, passiveEvent);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return this.visible ? this.props.children : this.props.placeholder ? this.props.placeholder : _react2.default.createElement('div', { style: { height: this.props.height }, className: 'lazyload-placeholder' });
      // <span ref={this.setRef} className="lazyload-custom-placeholder">
      //   {this.props.placeholder}
      // </span> :
      // <div ref={this.setRef} style={{ height: this.props.height }} className="lazyload-placeholder" />;
    }
  }]);

  return LazyLoad;
}(_react.Component);

LazyLoad.propTypes = {
  once: _propTypes2.default.bool,
  height: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
  offset: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.arrayOf(_propTypes2.default.number)]),
  overflow: _propTypes2.default.bool,
  resize: _propTypes2.default.bool,
  scroll: _propTypes2.default.bool,
  children: _propTypes2.default.node,
  throttle: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.bool]),
  debounce: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.bool]),
  placeholder: _propTypes2.default.node,
  scrollContainer: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
  unmountIfInvisible: _propTypes2.default.bool
};

LazyLoad.defaultProps = {
  once: false,
  offset: 0,
  overflow: false,
  resize: false,
  scroll: true,
  unmountIfInvisible: false
};

var getDisplayName = function getDisplayName(WrappedComponent) {
  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
};

var decorator = function decorator() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return function lazyload(WrappedComponent) {
    return function (_Component2) {
      _inherits(LazyLoadDecorated, _Component2);

      function LazyLoadDecorated() {
        _classCallCheck(this, LazyLoadDecorated);

        var _this2 = _possibleConstructorReturn(this, (LazyLoadDecorated.__proto__ || Object.getPrototypeOf(LazyLoadDecorated)).call(this));

        _this2.displayName = 'LazyLoad' + getDisplayName(WrappedComponent);
        return _this2;
      }

      _createClass(LazyLoadDecorated, [{
        key: 'render',
        value: function render() {
          return _react2.default.createElement(
            LazyLoad,
            options,
            _react2.default.createElement(WrappedComponent, this.props)
          );
        }
      }]);

      return LazyLoadDecorated;
    }(_react.Component);
  };
};

exports.lazyload = decorator;
exports.default = LazyLoad;
exports.forceCheck = lazyLoadHandler;
exports.forceVisible = forceVisible;

/***/ }),

/***/ 207:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LabelWrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return PreLabelContainer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(53);
var _templateObject=_taggedTemplateLiteral(['\n  color: #000000;\n  font-size: 1em;\n  text-align: ',';\n  display: ',';\n  font-family: ',';\n  align-self: ',';\n  line-height: ',';\n  text-transform: ',';\n  width: ',';\n  ',';\n  ',';\n  ',';\n  ',';\n  ',';\n   ::selection{\n    background: none;\n  }\n'],['\n  color: #000000;\n  font-size: 1em;\n  text-align: ',';\n  display: ',';\n  font-family: ',';\n  align-self: ',';\n  line-height: ',';\n  text-transform: ',';\n  width: ',';\n  ',';\n  ',';\n  ',';\n  ',';\n  ',';\n   ::selection{\n    background: none;\n  }\n']),_templateObject2=_taggedTemplateLiteral(['\n    color: ',';\n  '],['\n    color: ',';\n  ']),_templateObject3=_taggedTemplateLiteral(['\n    letter-spacing: ',';\n  '],['\n    letter-spacing: ',';\n  ']),_templateObject4=_taggedTemplateLiteral(['\n  font-size: ','em;\n  '],['\n  font-size: ','em;\n  ']),_templateObject5=_taggedTemplateLiteral(['\n    font-weight: ',';\n  '],['\n    font-weight: ',';\n  ']),_templateObject6=_taggedTemplateLiteral(['\n    margin: ','\n  '],['\n    margin: ','\n  ']),_templateObject7=_taggedTemplateLiteral(['\n  font-family: ',';\n  font-weight: bold;\n'],['\n  font-family: ',';\n  font-weight: bold;\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var LabelWrapper=__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].div(_templateObject,function(props){return props.textAlignment;},function(props){return props.block?'block':'inline';},function(props){return props.font?props.theme.fontSets[props.font]:props.isTitleNarrowMedium?''+props.theme.fontSets.narrowBold:''+props.theme.fontSets.narrowRegular;},function(props){return props.alignSelf?''+props.alignSelf:'center';},function(props){return props.lineHeight?''+props.lineHeight:1;},function(props){return props.isCapitalize?'uppercase':'normal';},function(props){return props.width;},function(props){return props.color&&Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* css */])(_templateObject2,props.theme.colors[props.color]);},function(props){return props.letterSpacing&&Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* css */])(_templateObject3,props.letterSpacing);},function(props){return props.size&&Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* css */])(_templateObject4,props.size);},function(props){return props.weight&&Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* css */])(_templateObject5,props.weight);},function(props){return props.margin&&Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* css */])(_templateObject6,props.margin);});var PreLabelContainer=__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].span(_templateObject7,function(props){return props.theme.fontSets.narrowMedium;});

/***/ }),

/***/ 209:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.on = on;
exports.off = off;
function on(el, eventName, callback, opts) {
  opts = opts || false;
  if (el.addEventListener) {
    el.addEventListener(eventName, callback, opts);
  } else if (el.attachEvent) {
    el.attachEvent("on" + eventName, function (e) {
      callback.call(el, e || window.event);
    });
  }
}

function off(el, eventName, callback, opts) {
  opts = opts || false;
  if (el.removeEventListener) {
    el.removeEventListener(eventName, callback, opts);
  } else if (el.detachEvent) {
    el.detachEvent("on" + eventName, callback);
  }
}

/***/ }),

/***/ 210:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

/**
 * @fileOverview Find scroll parent
 */

exports.default = function (node) {
  if (!(node instanceof HTMLElement)) {
    return document.documentElement;
  }

  var excludeStaticParent = node.style.position === 'absolute';
  var overflowRegex = /(scroll|auto)/;
  var parent = node;

  while (parent) {
    if (!parent.parentNode) {
      return node.ownerDocument || document.documentElement;
    }

    var style = window.getComputedStyle(parent);
    var position = style.position;
    var overflow = style.overflow;
    var overflowX = style['overflow-x'];
    var overflowY = style['overflow-y'];

    if (position === 'static' && excludeStaticParent) {
      parent = parent.parentNode;
      continue;
    }

    if (overflowRegex.test(overflow) && overflowRegex.test(overflowX) && overflowRegex.test(overflowY)) {
      return parent;
    }

    parent = parent.parentNode;
  }

  return node.ownerDocument || node.documentElement || document.documentElement;
};

/***/ }),

/***/ 211:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = debounce;
function debounce(func, wait, immediate) {
  var timeout = void 0;
  var args = void 0;
  var context = void 0;
  var timestamp = void 0;
  var result = void 0;

  var later = function later() {
    var last = +new Date() - timestamp;

    if (last < wait && last >= 0) {
      timeout = setTimeout(later, wait - last);
    } else {
      timeout = null;
      if (!immediate) {
        result = func.apply(context, args);
        if (!timeout) {
          context = null;
          args = null;
        }
      }
    }
  };

  return function debounced() {
    context = this;
    args = arguments;
    timestamp = +new Date();

    var callNow = immediate && !timeout;
    if (!timeout) {
      timeout = setTimeout(later, wait);
    }

    if (callNow) {
      result = func.apply(context, args);
      context = null;
      args = null;
    }

    return result;
  };
}

/***/ }),

/***/ 212:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = throttle;
/*eslint-disable */
function throttle(fn, threshhold, scope) {
  threshhold || (threshhold = 250);
  var last, deferTimer;
  return function () {
    var context = scope || this;

    var now = +new Date(),
        args = arguments;
    if (last && now < last + threshhold) {
      // hold on to it
      clearTimeout(deferTimer);
      deferTimer = setTimeout(function () {
        last = now;
        fn.apply(context, args);
      }, threshhold);
    } else {
      last = now;
      fn.apply(context, args);
    }
  };
}

/***/ }),

/***/ 213:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return TeamWrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TeamLogo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return TeamName; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(53);
var _templateObject=_taggedTemplateLiteral(['\n  display: flex;\n  align-items: center;\n  justify-content: left;\n  flex-direction:',';\n  border-radius:',';\n  margin:',';\n  ',';\n'],['\n  display: flex;\n  align-items: center;\n  justify-content: left;\n  flex-direction:',';\n  border-radius:',';\n  margin:',';\n  ',';\n']),_templateObject2=_taggedTemplateLiteral([' \n    justify-content: ',';\n  '],[' \n    justify-content: ',';\n  ']),_templateObject3=_taggedTemplateLiteral(['\n  height: ',';\n  image-rendering: optimizeSpeed;\n  -ms-interpolation-mode: nearest-neighbor;\n  ',';\n  ',';\n  ',';\n  ',';\n  ',';\n  ',';\n  ',';\n  ',';\n  ',';\n   ',';\n  &.placeholder {\n    max-height: 33px;\n  }\n'],['\n  height: ',';\n  image-rendering: optimizeSpeed;\n  -ms-interpolation-mode: nearest-neighbor;\n  ',';\n  ',';\n  ',';\n  ',';\n  ',';\n  ',';\n  ',';\n  ',';\n  ',';\n   ',';\n  &.placeholder {\n    max-height: 33px;\n  }\n']),_templateObject4=_taggedTemplateLiteral(['\n    width: ',';\n    height: auto;\n  '],['\n    width: ',';\n    height: auto;\n  ']),_templateObject5=_taggedTemplateLiteral(['\n    height: ',';;\n  '],['\n    height: ',';;\n  ']),_templateObject6=_taggedTemplateLiteral(['\n    height: 34px;\n    width: 34px;\n  '],['\n    height: 34px;\n    width: 34px;\n  ']),_templateObject7=_taggedTemplateLiteral(['\n    height: 45px;\n  '],['\n    height: 45px;\n  ']),_templateObject8=_taggedTemplateLiteral(['\n    height: 20px;\n    width: 30px;\n  '],['\n    height: 20px;\n    width: 30px;\n  ']),_templateObject9=_taggedTemplateLiteral(['\n    height: 50px;\n  '],['\n    height: 50px;\n  ']),_templateObject10=_taggedTemplateLiteral(['\n    height: 28px;\n    width: 28px;\n  '],['\n    height: 28px;\n    width: 28px;\n  ']),_templateObject11=_taggedTemplateLiteral(['\n    height: 36px;\n  '],['\n    height: 36px;\n  ']),_templateObject12=_taggedTemplateLiteral(['\n    border-radius: 4px;\n    height: 32px;\n    width: 32px;\n  '],['\n    border-radius: 4px;\n    height: 32px;\n    width: 32px;\n  ']),_templateObject13=_taggedTemplateLiteral(['\n    height: 15px;\n    width: 20px;\n  '],['\n    height: 15px;\n    width: 20px;\n  ']),_templateObject14=_taggedTemplateLiteral(['\n  color: ',';\n  font-weight: ',';\n  margin-left: ','em;\n  margin-top: ','px;\n  margin-right: ','em;\n  text-align: ',';\n  font-size: 18px;\n  text-transform: ',';\n  ',';\n  ',';\n  width: ',';\n  ',';\n  text-overflow: ellipsis;\n  overflow: hidden;\n'],['\n  color: ',';\n  font-weight: ',';\n  margin-left: ','em;\n  margin-top: ','px;\n  margin-right: ','em;\n  text-align: ',';\n  font-size: 18px;\n  text-transform: ',';\n  ',';\n  ',';\n  width: ',';\n  ',';\n  text-overflow: ellipsis;\n  overflow: hidden;\n']),_templateObject15=_taggedTemplateLiteral([' \n    font-size: ','px;\n  '],[' \n    font-size: ','px;\n  ']),_templateObject16=_taggedTemplateLiteral(['\n    font-family: ',';\n  '],['\n    font-family: ',';\n  ']),_templateObject17=_taggedTemplateLiteral([' \n    white-space: ',';\n  '],[' \n    white-space: ',';\n  ']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var TeamWrapper=__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].div(_templateObject,function(props){return props.isAColumn?'column':'row';},function(props){return props.isSquad?'50%':'';},function(props){return props.marginWrapper?props.marginWrapper:'0px';},function(props){return props.justifyContent&&Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* css */])(_templateObject2,props.justifyContent);});var TeamLogo=__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].img(_templateObject3,function(props){return props.isMatchPage?'85px':'30px';},function(props){return props.width&&Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* css */])(_templateObject4,props.width);},function(props){return props.height&&Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* css */])(_templateObject5,props.height);},function(props){return props.isPlayer&&Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* css */])(_templateObject6);},function(props){return props.isForma&&Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* css */])(_templateObject7);},function(props){return props.isFlag&&Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* css */])(_templateObject8);},function(props){return props.isHeader&&Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* css */])(_templateObject9);},function(props){return props.isStripCalendar&&Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* css */])(_templateObject10);},function(props){return props.isWorldCup&&Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* css */])(_templateObject11);},function(props){return props.isCorriereCalendar&&Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* css */])(_templateObject12);},function(props){return props.noFavStar&&Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* css */])(_templateObject13);});var TeamName=__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].div(_templateObject14,function(props){return props.color;},function(props){return props.weight;},function(props){return props.marginLeft;},function(props){return props.marginTop;},function(props){return props.marginRight;},function(props){return props.alignment?props.alignment:'left';},function(props){return props.isUpperCase?'uppercase':'initial';},function(props){return props.size&&Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* css */])(_templateObject15,props.size);},function(props){return props.font&&Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* css */])(_templateObject16,props.theme.fontSets[props.font]);},function(props){return props.textWidth?props.textWidth:'auto';},function(props){return props.whiteSpace&&Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* css */])(_templateObject17,props.whiteSpace);});

/***/ }),

/***/ 214:
/***/ (function(module, exports) {

module.exports = "data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAASABIAAD/4QCMRXhpZgAATU0AKgAAAAgABQESAAMAAAABAAEAAAEaAAUAAAABAAAASgEbAAUAAAABAAAAUgEoAAMAAAABAAIAAIdpAAQAAAABAAAAWgAAAAAAAABIAAAAAQAAAEgAAAABAAOgAQADAAAAAQABAACgAgAEAAAAAQAAACigAwAEAAAAAQAAACkAAAAA/+0AOFBob3Rvc2hvcCAzLjAAOEJJTQQEAAAAAAAAOEJJTQQlAAAAAAAQ1B2M2Y8AsgTpgAmY7PhCfv/AABEIACkAKAMBIgACEQEDEQH/xAAfAAABBQEBAQEBAQAAAAAAAAAAAQIDBAUGBwgJCgv/xAC1EAACAQMDAgQDBQUEBAAAAX0BAgMABBEFEiExQQYTUWEHInEUMoGRoQgjQrHBFVLR8CQzYnKCCQoWFxgZGiUmJygpKjQ1Njc4OTpDREVGR0hJSlNUVVZXWFlaY2RlZmdoaWpzdHV2d3h5eoOEhYaHiImKkpOUlZaXmJmaoqOkpaanqKmqsrO0tba3uLm6wsPExcbHyMnK0tPU1dbX2Nna4eLj5OXm5+jp6vHy8/T19vf4+fr/xAAfAQADAQEBAQEBAQEBAAAAAAAAAQIDBAUGBwgJCgv/xAC1EQACAQIEBAMEBwUEBAABAncAAQIDEQQFITEGEkFRB2FxEyIygQgUQpGhscEJIzNS8BVictEKFiQ04SXxFxgZGiYnKCkqNTY3ODk6Q0RFRkdISUpTVFVWV1hZWmNkZWZnaGlqc3R1dnd4eXqCg4SFhoeIiYqSk5SVlpeYmZqio6Slpqeoqaqys7S1tre4ubrCw8TFxsfIycrS09TV1tfY2dri4+Tl5ufo6ery8/T19vf4+fr/2wBDAAkGBxQHBhURBw4SFRIXEhIVFREXGBITHBAXFRcWFhcVFhkaHSggGBolGxgVITEiJSkrLi4vFx8zODMtOSgtLiv/2wBDAQoKCgUFBQ4FBQ4rGRMZKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKyv/3QAEAAP/2gAMAwEAAhEDEQA/APYqp6nqC6fBukBJJwAO5xn8BVysDxd/qI/Xc3H4UAVU8TSBvnjQj0G4frW/p18t/b74uOcFT1U+lcJXReETzIP9w4/OgDo6KKKAP//Q9irP1u0F3p7DuoLKfcD/AAqPUdbSykK4LOOoHGPqawNQ1qS9Urwqn+Ed/qe9AGbXYeHbQW+nhv4nwx+nYflXH1fsNWksVxEQVz908j8O4oA7aisnTtdS8kCSKUc9B1BPoD/jWtQB/9HpL1t165P99/5moKlu/wDj6f8A33/9CNRUAFFFFAElucXCkf3l/mK3vPf+8awYP9ev+8v8xW7QB//Z"

/***/ }),

/***/ 215:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _throttle = __webpack_require__(198);

var _throttle2 = _interopRequireDefault(_throttle);

var _style = __webpack_require__(227);

var _style2 = _interopRequireDefault(_style);

var _utils = __webpack_require__(197);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* global window */

var Col = function (_React$Component) {
  _inherits(Col, _React$Component);

  function Col() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Col);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Col.__proto__ || Object.getPrototypeOf(Col)).call.apply(_ref, [this].concat(args))), _this), _this.componentWillMount = function () {
      _this.setScreenClass();
    }, _this.componentDidMount = function () {
      _this.eventListener = (0, _throttle2.default)(_this.setScreenClass, 100);
      window.addEventListener('resize', _this.eventListener);
    }, _this.componentWillUnmount = function () {
      _this.eventListener.cancel();
      window.removeEventListener('resize', _this.eventListener);
    }, _this.setScreenClass = function () {
      _this.setState({ screenClass: (0, _utils.getScreenClass)(_this.context) });
    }, _this.render = function () {
      var _this$props = _this.props,
          children = _this$props.children,
          xs = _this$props.xs,
          sm = _this$props.sm,
          md = _this$props.md,
          lg = _this$props.lg,
          xl = _this$props.xl,
          offset = _this$props.offset,
          pull = _this$props.pull,
          push = _this$props.push,
          debug = _this$props.debug,
          style = _this$props.style,
          otherProps = _objectWithoutProperties(_this$props, ['children', 'xs', 'sm', 'md', 'lg', 'xl', 'offset', 'pull', 'push', 'debug', 'style']);

      var theStyle = (0, _style2.default)({
        width: {
          xs: xs, sm: sm, md: md, lg: lg, xl: xl
        },
        offset: offset,
        pull: pull,
        push: push,
        debug: debug,
        screenClass: _this.state.screenClass,
        gutterWidth: _this.context.gutterWidth,
        moreStyle: style,
        gridColumns: _this.context.gridColumns
      });
      return _react2.default.createElement(
        'div',
        _extends({ style: theStyle }, otherProps),
        children
      );
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  return Col;
}(_react2.default.Component);

Col.propTypes = {
  /**
   * Content of the column
   */
  children: _propTypes2.default.node,
  /**
   * The width of the column for screenclass `xs`, between 0 and 12
   */
  xs: _propTypes2.default.number,
  /**
   * The width of the column for screenclass `sm`, between 0 and 12
   */
  sm: _propTypes2.default.number,
  /**
   * The width of the column for screenclass `md`, between 0 and 12
   */
  md: _propTypes2.default.number,
  /**
   * The width of the column for screenclass `lg`, between 0 and 12
   */
  lg: _propTypes2.default.number,
  /**
   * The width of the column for screenclass `xl`, between 0 and 12
   */
  xl: _propTypes2.default.number,
  /**
   * The offset of this column for all screenclasses
   */
  offset: _propTypes2.default.shape({
    xs: _propTypes2.default.number,
    sm: _propTypes2.default.number,
    md: _propTypes2.default.number,
    lg: _propTypes2.default.number,
    xl: _propTypes2.default.number
  }),
  /**
  * The amount this column is pushed to the right for all screenclasses
  */
  push: _propTypes2.default.shape({
    xs: _propTypes2.default.number,
    sm: _propTypes2.default.number,
    md: _propTypes2.default.number,
    lg: _propTypes2.default.number,
    xl: _propTypes2.default.number
  }),
  /**
   * The amount this column is pulled to the left for all screenclasses
   */
  pull: _propTypes2.default.shape({
    xs: _propTypes2.default.number,
    sm: _propTypes2.default.number,
    md: _propTypes2.default.number,
    lg: _propTypes2.default.number,
    xl: _propTypes2.default.number
  }),
  /**
   * Optional styling
   */
  style: _propTypes2.default.objectOf(_propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string])),
  /**
   * Set to apply some debug styling
   */
  debug: _propTypes2.default.bool
};
Col.defaultProps = {
  children: null,
  xs: null,
  sm: null,
  md: null,
  lg: null,
  xl: null,
  offset: {},
  push: {},
  pull: {},
  style: {},
  debug: false
};
Col.contextTypes = {
  serverSideScreenClass: _propTypes2.default.oneOf(['xs', 'sm', 'md', 'lg', 'xl']),
  breakpoints: _propTypes2.default.arrayOf(_propTypes2.default.number),
  gutterWidth: _propTypes2.default.number,
  gridColumns: _propTypes2.default.number
};
exports.default = Col;

/***/ }),

/***/ 216:
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(200),
    now = __webpack_require__(217),
    toNumber = __webpack_require__(219);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        timeWaiting = wait - timeSinceLastCall;

    return maxing
      ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
      : timeWaiting;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        clearTimeout(timerId);
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

module.exports = debounce;


/***/ }),

/***/ 217:
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(201);

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

module.exports = now;


/***/ }),

/***/ 218:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(12)))

/***/ }),

/***/ 219:
/***/ (function(module, exports, __webpack_require__) {

var baseTrim = __webpack_require__(220),
    isObject = __webpack_require__(200),
    isSymbol = __webpack_require__(222);

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = baseTrim(value);
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = toNumber;


/***/ }),

/***/ 220:
/***/ (function(module, exports, __webpack_require__) {

var trimmedEndIndex = __webpack_require__(221);

/** Used to match leading whitespace. */
var reTrimStart = /^\s+/;

/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */
function baseTrim(string) {
  return string
    ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '')
    : string;
}

module.exports = baseTrim;


/***/ }),

/***/ 221:
/***/ (function(module, exports) {

/** Used to match a single whitespace character. */
var reWhitespace = /\s/;

/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */
function trimmedEndIndex(string) {
  var index = string.length;

  while (index-- && reWhitespace.test(string.charAt(index))) {}
  return index;
}

module.exports = trimmedEndIndex;


/***/ }),

/***/ 222:
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(223),
    isObjectLike = __webpack_require__(226);

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && baseGetTag(value) == symbolTag);
}

module.exports = isSymbol;


/***/ }),

/***/ 223:
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(202),
    getRawTag = __webpack_require__(224),
    objectToString = __webpack_require__(225);

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

module.exports = baseGetTag;


/***/ }),

/***/ 224:
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(202);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;


/***/ }),

/***/ 225:
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),

/***/ 226:
/***/ (function(module, exports) {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ }),

/***/ 227:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _utils = __webpack_require__(197);

var hasWidth = function hasWidth(widths) {
  return Object.keys(widths).reduce(function (acc, cur) {
    return acc || widths[cur];
  }, false);
};

var getWidth = function getWidth(width, gridColumns) {
  if (typeof width !== 'number') return undefined;
  var normalizedWidth = Math.max(0, Math.min(gridColumns, width));
  return 100 / gridColumns * normalizedWidth + '%';
};

exports.default = function (_ref) {
  var _ref$width = _ref.width,
      width = _ref$width === undefined ? {} : _ref$width,
      _ref$offset = _ref.offset,
      offset = _ref$offset === undefined ? {} : _ref$offset,
      _ref$pull = _ref.pull,
      pull = _ref$pull === undefined ? {} : _ref$pull,
      _ref$push = _ref.push,
      push = _ref$push === undefined ? {} : _ref$push,
      debug = _ref.debug,
      screenClass = _ref.screenClass,
      gutterWidth = _ref.gutterWidth,
      moreStyle = _ref.moreStyle,
      gridColumns = _ref.gridColumns;

  var theGutterWidth = typeof gutterWidth === 'number' ? gutterWidth : _utils.defaultGutterWidth;
  var theGridColumns = typeof gridColumns === 'number' ? gridColumns : _utils.defaultGridColumns;

  var styles = _extends({
    boxSizing: 'border-box',
    minHeight: '1px',
    position: 'relative',
    paddingLeft: theGutterWidth / 2 + 'px',
    paddingRight: theGutterWidth / 2 + 'px',
    width: '100%',
    overflow: 'hidden'
  }, moreStyle);

  if (debug) {
    styles.outline = '1px solid silver';
    styles.background = 'rgba(0,0,0,.05)';
  }

  styles.flexBasis = '100%';
  styles.flexGrow = 0;
  styles.flexShrink = 0;
  styles.maxWidth = '100%';
  styles.marginLeft = '0%';
  styles.right = 'auto';
  styles.left = 'auto';

  _utils.screenClasses.forEach(function (size, index) {
    if (_utils.screenClasses.indexOf(screenClass) >= index) {
      styles.flexBasis = getWidth(width[size], theGridColumns) || styles.flexBasis;
      styles.maxWidth = getWidth(width[size], theGridColumns) || styles.maxWidth;
      styles.marginLeft = getWidth(offset[size], theGridColumns) || styles.marginLeft;
      styles.right = getWidth(pull[size], theGridColumns) || styles.right;
      styles.left = getWidth(push[size], theGridColumns) || styles.left;
    }
  });

  if (!hasWidth(width)) {
    styles.flexBasis = 0;
    styles.flexGrow = 1;
  }

  return styles;
};

/***/ }),

/***/ 228:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _throttle = __webpack_require__(198);

var _throttle2 = _interopRequireDefault(_throttle);

var _style = __webpack_require__(229);

var _style2 = _interopRequireDefault(_style);

var _utils = __webpack_require__(197);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* global window */

var Container = function (_React$Component) {
  _inherits(Container, _React$Component);

  function Container() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Container);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Container.__proto__ || Object.getPrototypeOf(Container)).call.apply(_ref, [this].concat(args))), _this), _this.componentWillMount = function () {
      _this.setScreenClass();
    }, _this.componentDidMount = function () {
      _this.eventListener = (0, _throttle2.default)(_this.setScreenClass, 100);
      window.addEventListener('resize', _this.eventListener);
    }, _this.componentWillUnmount = function () {
      _this.eventListener.cancel();
      window.removeEventListener('resize', _this.eventListener);
    }, _this.setScreenClass = function () {
      _this.setState({ screenClass: (0, _utils.getScreenClass)(_this.context) });
    }, _this.render = function () {
      var _this$props = _this.props,
          children = _this$props.children,
          fluid = _this$props.fluid,
          xs = _this$props.xs,
          sm = _this$props.sm,
          md = _this$props.md,
          lg = _this$props.lg,
          xl = _this$props.xl,
          style = _this$props.style,
          otherProps = _objectWithoutProperties(_this$props, ['children', 'fluid', 'xs', 'sm', 'md', 'lg', 'xl', 'style']);

      var theStyle = (0, _style2.default)({
        fluid: fluid,
        xs: xs,
        sm: sm,
        md: md,
        lg: lg,
        xl: xl,
        screenClass: _this.state.screenClass,
        containerWidths: _this.context.containerWidths,
        gutterWidth: _this.context.gutterWidth,
        moreStyle: style
      });
      return _react2.default.createElement(
        'div',
        _extends({ style: theStyle }, otherProps),
        children,
        _react2.default.createElement('span', { style: (0, _style.getAfterStyle)() })
      );
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  return Container;
}(_react2.default.Component);

Container.propTypes = {
  /**
   * Content of the component
   */
  children: _propTypes2.default.node.isRequired,
  /**
   * True makes the container full-width, false fixed-width
   */
  fluid: _propTypes2.default.bool,
  /**
   * This is in combination with fluid enabled
   * True makes container fluid only in xs, not present means fluid everywhere
   */
  xs: _propTypes2.default.bool,
  /**
   * This is in combination with fluid enabled
   * True makes container fluid only in sm, not present means fluid everywhere
   */
  sm: _propTypes2.default.bool,
  /**
   * This is in combination with fluid enabled
   * True makes container fluid only in md, not present means fluid everywhere
   */
  md: _propTypes2.default.bool,
  /**
   * This is in combination with fluid enabled
   * True makes container fluid only in lg, not present means fluid everywhere
   */
  lg: _propTypes2.default.bool,
  /**
   * This is in combination with fluid enabled
   * True makes container fluid only in xl, not present means fluid everywhere
   */
  xl: _propTypes2.default.bool,
  /**
   * Optional styling
   */
  style: _propTypes2.default.objectOf(_propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]))
};
Container.contextTypes = {
  serverSideScreenClass: _propTypes2.default.oneOf(['xs', 'sm', 'md', 'lg', 'xl']),
  breakpoints: _propTypes2.default.arrayOf(_propTypes2.default.number),
  containerWidths: _propTypes2.default.arrayOf(_propTypes2.default.number),
  gutterWidth: _propTypes2.default.number
};
Container.defaultProps = {
  fluid: false,
  xs: false,
  sm: false,
  md: false,
  lg: false,
  xl: false,
  style: {}
};
exports.default = Container;

/***/ }),

/***/ 229:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getAfterStyle = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _utils = __webpack_require__(197);

exports.default = function (_ref) {
  var fluid = _ref.fluid,
      xs = _ref.xs,
      sm = _ref.sm,
      md = _ref.md,
      lg = _ref.lg,
      xl = _ref.xl,
      screenClass = _ref.screenClass,
      containerWidths = _ref.containerWidths,
      gutterWidth = _ref.gutterWidth,
      moreStyle = _ref.moreStyle;

  var theContainerWidths = containerWidths && containerWidths.length ? containerWidths : _utils.defaultContainerWidths;
  var theGutterWidth = typeof gutterWidth === 'number' ? gutterWidth : _utils.defaultGutterWidth;

  var styles = _extends({
    boxSizing: 'border-box',
    position: 'relative',
    marginLeft: 'auto',
    marginRight: 'auto',
    paddingLeft: theGutterWidth / 2 + 'px',
    paddingRight: theGutterWidth / 2 + 'px'
  }, moreStyle);

  if (fluid && !sm && !md && !lg && !xl) {
    return styles;
  }

  if (screenClass === 'sm' && theContainerWidths[0] && !sm && !xs) {
    styles.maxWidth = theContainerWidths[0] + 'px';
  }

  if (screenClass === 'md' && theContainerWidths[1] && !md) {
    styles.maxWidth = theContainerWidths[1] + 'px';
  }

  if (screenClass === 'lg' && theContainerWidths[2] && !lg) {
    styles.maxWidth = theContainerWidths[2] + 'px';
  }

  if (screenClass === 'xl' && theContainerWidths[3] && !xl) {
    styles.maxWidth = theContainerWidths[3] + 'px';
  }

  return styles;
};

var getAfterStyle = exports.getAfterStyle = function getAfterStyle() {
  return {
    display: 'table',
    clear: 'both'
  };
};

/***/ }),

/***/ 230:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _style = __webpack_require__(231);

var _style2 = _interopRequireDefault(_style);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Row = function (_React$Component) {
  _inherits(Row, _React$Component);

  function Row() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Row);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Row.__proto__ || Object.getPrototypeOf(Row)).call.apply(_ref, [this].concat(args))), _this), _this.getChildContext = function () {
      return {
        gutterWidth: _this.props.nogutter ? 0 : _this.context.gutterWidth
      };
    }, _this.render = function () {
      var _this$props = _this.props,
          children = _this$props.children,
          style = _this$props.style,
          align = _this$props.align,
          debug = _this$props.debug,
          nogutter = _this$props.nogutter,
          otherProps = _objectWithoutProperties(_this$props, ['children', 'style', 'align', 'debug', 'nogutter']);

      var theStyle = (0, _style2.default)({
        gutterWidth: nogutter ? 0 : _this.context.gutterWidth,
        align: align,
        debug: debug,
        moreStyle: style
      });
      return _react2.default.createElement(
        'div',
        _extends({ style: theStyle }, otherProps),
        children
      );
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  return Row;
}(_react2.default.Component);

Row.propTypes = {
  /**
   * Content of the element
   */
  children: _propTypes2.default.node.isRequired,
  /**
  * Column alignment
  */
  align: _propTypes2.default.oneOf(['normal', 'start', 'center', 'end']),
  /**
  * No gutter for this row
  */
  nogutter: _propTypes2.default.bool,
  /**
  * Optional styling
  */
  style: _propTypes2.default.objectOf(_propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string])),
  /**
    * Set to apply some debug styling
    */
  debug: _propTypes2.default.bool
};
Row.defaultProps = {
  align: 'normal',
  nogutter: false,
  style: {},
  debug: false
};
Row.contextTypes = {
  gutterWidth: _propTypes2.default.number
};
Row.childContextTypes = {
  gutterWidth: _propTypes2.default.number
};
exports.default = Row;

/***/ }),

/***/ 231:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _utils = __webpack_require__(197);

exports.default = function (_ref) {
  var gutterWidth = _ref.gutterWidth,
      align = _ref.align,
      debug = _ref.debug,
      moreStyle = _ref.moreStyle;

  var theGutterWidth = typeof gutterWidth === 'number' ? gutterWidth : _utils.defaultGutterWidth;

  var alignItems = align;
  if (align === 'start') alignItems = 'flex-start';
  if (align === 'end') alignItems = 'flex-end';

  var styles = _extends({
    marginLeft: '-' + theGutterWidth / 2 + 'px',
    marginRight: '-' + theGutterWidth / 2 + 'px',
    display: 'flex',
    flexWrap: 'wrap',
    flexGrow: 0,
    flexShrink: 0,
    alignItems: alignItems
  }, moreStyle);

  if (debug) {
    styles.background = 'rgba(128,128,128,.05)';
  }

  return styles;
};

/***/ }),

/***/ 232:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _throttle = __webpack_require__(198);

var _throttle2 = _interopRequireDefault(_throttle);

var _style = __webpack_require__(233);

var style = _interopRequireWildcard(_style);

var _utils = __webpack_require__(197);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* global window */

var Hidden = function (_React$Component) {
  _inherits(Hidden, _React$Component);

  function Hidden() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Hidden);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Hidden.__proto__ || Object.getPrototypeOf(Hidden)).call.apply(_ref, [this].concat(args))), _this), _this.componentWillMount = function () {
      _this.setScreenClass();
    }, _this.componentDidMount = function () {
      _this.eventListener = (0, _throttle2.default)(_this.setScreenClass, 100);
      window.addEventListener('resize', _this.eventListener);
    }, _this.componentWillUnmount = function () {
      _this.eventListener.cancel();
      window.removeEventListener('resize', _this.eventListener);
    }, _this.setScreenClass = function () {
      _this.setState({ screenClass: (0, _utils.getScreenClass)(_this.context) });
    }, _this.render = function () {
      if (style.hidden({
        screenClass: _this.state.screenClass,
        xs: _this.props.xs,
        sm: _this.props.sm,
        md: _this.props.md,
        lg: _this.props.lg,
        xl: _this.props.xl
      })) return false;
      return _react2.default.createElement(
        _react2.default.Fragment,
        null,
        _this.props.children
      );
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  return Hidden;
}(_react2.default.Component);

Hidden.propTypes = {
  /**
   * Content of the component
   */
  children: _propTypes2.default.node.isRequired,
  /**
   * Hide on extra small devices
   */
  xs: _propTypes2.default.bool,
  /**
   * Hide on small devices
   */
  sm: _propTypes2.default.bool,
  /**
   * Hide on medium devices
   */
  md: _propTypes2.default.bool,
  /**
   * Hide on large devices
   */
  lg: _propTypes2.default.bool,
  /**
   * Hide on xlarge devices
   */
  xl: _propTypes2.default.bool
};
Hidden.contextTypes = {
  serverSideScreenClass: _propTypes2.default.oneOf(['xs', 'sm', 'md', 'lg', 'xl']),
  breakpoints: _propTypes2.default.arrayOf(_propTypes2.default.number)
};
Hidden.defaultProps = {
  xs: false,
  sm: false,
  md: false,
  lg: false,
  xl: false
};
exports.default = Hidden;

/***/ }),

/***/ 233:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var hidden = exports.hidden = function hidden(_ref) {
  var screenClass = _ref.screenClass,
      xs = _ref.xs,
      sm = _ref.sm,
      md = _ref.md,
      lg = _ref.lg,
      xl = _ref.xl;

  if (screenClass === 'xl') return xl;
  if (screenClass === 'lg') return lg;
  if (screenClass === 'md') return md;
  if (screenClass === 'sm') return sm;
  return xs;
};

exports.default = hidden;

/***/ }),

/***/ 234:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _throttle = __webpack_require__(198);

var _throttle2 = _interopRequireDefault(_throttle);

var _style = __webpack_require__(235);

var style = _interopRequireWildcard(_style);

var _utils = __webpack_require__(197);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* global window */

var Visible = function (_React$Component) {
  _inherits(Visible, _React$Component);

  function Visible() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Visible);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Visible.__proto__ || Object.getPrototypeOf(Visible)).call.apply(_ref, [this].concat(args))), _this), _this.componentWillMount = function () {
      _this.setScreenClass();
    }, _this.componentDidMount = function () {
      _this.eventListener = (0, _throttle2.default)(_this.setScreenClass, 100);
      window.addEventListener('resize', _this.eventListener);
    }, _this.componentWillUnmount = function () {
      _this.eventListener.cancel();
      window.removeEventListener('resize', _this.eventListener);
    }, _this.setScreenClass = function () {
      _this.setState({ screenClass: (0, _utils.getScreenClass)(_this.context) });
    }, _this.render = function () {
      if (!style.visible({
        screenClass: _this.state.screenClass,
        xs: _this.props.xs,
        sm: _this.props.sm,
        md: _this.props.md,
        lg: _this.props.lg,
        xl: _this.props.xl
      })) return false;
      return _react2.default.createElement(
        _react2.default.Fragment,
        null,
        _this.props.children
      );
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  return Visible;
}(_react2.default.Component);

Visible.propTypes = {
  /**
   * Content of the component
   */
  children: _propTypes2.default.node.isRequired,
  /**
   * Show on extra small devices
   */
  xs: _propTypes2.default.bool,
  /**
   * Show on small devices
   */
  sm: _propTypes2.default.bool,
  /**
   * Show on medium devices
   */
  md: _propTypes2.default.bool,
  /**
   * Show on large devices
   */
  lg: _propTypes2.default.bool,
  /**
   * Show on xl devices
   */
  xl: _propTypes2.default.bool
};
Visible.contextTypes = {
  serverSideScreenClass: _propTypes2.default.oneOf(['xs', 'sm', 'md', 'lg', 'xl']),
  breakpoints: _propTypes2.default.arrayOf(_propTypes2.default.number)
};
Visible.defaultProps = {
  xs: false,
  sm: false,
  md: false,
  lg: false,
  xl: false
};
exports.default = Visible;

/***/ }),

/***/ 235:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var visible = exports.visible = function visible(_ref) {
  var screenClass = _ref.screenClass,
      xs = _ref.xs,
      sm = _ref.sm,
      md = _ref.md,
      lg = _ref.lg,
      xl = _ref.xl;

  if (screenClass === 'xl') return xl;
  if (screenClass === 'lg') return lg;
  if (screenClass === 'md') return md;
  if (screenClass === 'sm') return sm;
  return xs;
};

exports.default = visible;

/***/ }),

/***/ 236:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _throttle = __webpack_require__(198);

var _throttle2 = _interopRequireDefault(_throttle);

var _utils = __webpack_require__(197);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* global window */
/* eslint no-console: off */

var ScreenClassRender = function (_React$Component) {
  _inherits(ScreenClassRender, _React$Component);

  function ScreenClassRender() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ScreenClassRender);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ScreenClassRender.__proto__ || Object.getPrototypeOf(ScreenClassRender)).call.apply(_ref, [this].concat(args))), _this), _this.componentWillMount = function () {
      _this.setScreenClass();
    }, _this.componentDidMount = function () {
      _this.eventListener = (0, _throttle2.default)(_this.setScreenClass, 100);
      window.addEventListener('resize', _this.eventListener);
    }, _this.componentWillUnmount = function () {
      _this.eventListener.cancel();
      window.removeEventListener('resize', _this.eventListener);
    }, _this.setScreenClass = function () {
      _this.setState({ screenClass: (0, _utils.getScreenClass)(_this.context) });
    }, _this.getStyle = function () {
      return _this.props.style(_this.state.screenClass, _this.props.children.props);
    }, _this.render = function () {
      if (_this.props.render) {
        return _react2.default.createElement(
          _react2.default.Fragment,
          null,
          _this.props.render(_this.state.screenClass)
        );
      }
      if (!_this.warned) {
        console.warn('Please use the render prop of ScreenClassRender. Using style and children is deprecated and will be removed in the next major release.');
        _this.warned = true;
      }
      if (_this.props.style) {
        return _react2.default.cloneElement(_this.props.children, { style: _this.getStyle() });
      }
      return false;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  return ScreenClassRender;
}(_react2.default.Component);

ScreenClassRender.propTypes = {
  /**
   * Deprecated, will be removed in the next major release
   */
  children: _propTypes2.default.element,
  /**
   * Deprecated, will be removed in the next major release
   */
  style: _propTypes2.default.func,
  /**
   * The function which return value will be rendered.
   * Will be called with one argument: the screen class.
   */
  render: _propTypes2.default.func
};
ScreenClassRender.defaultProps = {
  children: null,
  style: null,
  render: null
};
ScreenClassRender.contextTypes = {
  serverSideScreenClass: _propTypes2.default.oneOf(['xs', 'sm', 'md', 'lg', 'xl']),
  breakpoints: _propTypes2.default.arrayOf(_propTypes2.default.number)
};
exports.default = ScreenClassRender;

/***/ }),

/***/ 255:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(257);
var StandingButton=function StandingButton(_ref){var background=_ref.background,label=_ref.label,color=_ref.color,linkTo=_ref.linkTo,borderColor=_ref.borderColor,width=_ref.width,isTitleNarrowMedium=_ref.isTitleNarrowMedium,margin=_ref.margin,size=_ref.size;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__styles__["b" /* ButtonWrapper */],{background:background,href:linkTo,borderColor:borderColor,width:width,margin:margin},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* ButtonLabel */],{color:color,isTitleNarrowMedium:isTitleNarrowMedium,size:size},label));};StandingButton.propTypes={label:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,color:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,background:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,linkTo:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,borderColor:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,width:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,isTitleNarrowMedium:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,margin:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,size:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string};/* harmony default export */ __webpack_exports__["a"] = (StandingButton);

/***/ }),

/***/ 256:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants__ = __webpack_require__(0);
var Result=function Result(_ref){var awayRes=_ref.awayRes,homeRes=_ref.homeRes,size=_ref.size,margin=_ref.margin,withCursor=_ref.withCursor,status=_ref.status,isFav=_ref.isFav,isWorldCup=_ref.isWorldCup,isMobile=_ref.isMobile,awayPenRes=_ref.awayPenRes,homePenRes=_ref.homePenRes,isNext=_ref.isNext;var isHomeWinner=function isHomeWinner(){return Number(homeRes)+Number(homePenRes)>Number(awayRes)+Number(awayPenRes);};var isAwayWinner=function isAwayWinner(){return Number(homeRes)+Number(homePenRes)<Number(awayRes)+Number(awayPenRes);};var isLive=function isLive(){return status===__WEBPACK_IMPORTED_MODULE_3__constants__["_65" /* LIVE_STATUS */];};var displayResult=function displayResult(res,penRes){if(status===__WEBPACK_IMPORTED_MODULE_3__constants__["_69" /* POSTPONED_STATUS */]||status===__WEBPACK_IMPORTED_MODULE_3__constants__["_74" /* PREMATCH_STATUS */]||status===__WEBPACK_IMPORTED_MODULE_3__constants__["o" /* FIXTURE */]){return'-';}return Number(res)+Number(penRes);};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__styles__["b" /* ResultWrapper */],{className:isLive()?'liveColor':'black',withCursor:withCursor,margin:margin,isFav:isFav,isCorr:isMobile},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* ResultLabel */],{color:isWorldCup?'black':isLive()?'liveColor':'black',size:size,customMargin:isNext?'0px 6px':'8px 6px',font:isWorldCup?'narrowRegular':isHomeWinner()?'narrowMedium':'narrowRegular',isMobile:isMobile},displayResult(homeRes,homePenRes)),isWorldCup&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* ResultLabel */],{color:'black',size:size,customMargin:isNext?'0px':'3px 0'},'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* ResultLabel */],{color:isWorldCup?'black':isLive()?'liveColor':'black',size:size,customMargin:isNext?'0px 6px':'8px 6px',font:isWorldCup?'narrowRegular':isAwayWinner()?'narrowMedium':'narrowRegular',isMobile:isMobile},displayResult(awayRes,awayPenRes)));};Result.propTypes={awayRes:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,homeRes:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,//color: PropTypes.string,
size:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,margin:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,withCursor:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,isMobile:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,isFav:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,status:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,isWorldCup:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,awayPenRes:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,homePenRes:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,isNext:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool};/* harmony default export */ __webpack_exports__["a"] = (Result);

/***/ }),

/***/ 257:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ButtonWrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ButtonLabel; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(53);
var _templateObject=_taggedTemplateLiteral(['\n  background: ',';\n  display: flex;\n  align-self: center;\n  white-space: nowrap;\n  justify-content: center;\n  margin: ',';\n  border-radius: 2px;\n  border: 1px solid ',';\n  cursor: pointer;\n  text-decoration: none;\n  width: ',';\n'],['\n  background: ',';\n  display: flex;\n  align-self: center;\n  white-space: nowrap;\n  justify-content: center;\n  margin: ',';\n  border-radius: 2px;\n  border: 1px solid ',';\n  cursor: pointer;\n  text-decoration: none;\n  width: ',';\n']),_templateObject2=_taggedTemplateLiteral(['\n  color: ',';\n  font-size: ',';\n  padding: 8px;\n  font-family: ',';\n'],['\n  color: ',';\n  font-size: ',';\n  padding: 8px;\n  font-family: ',';\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var ButtonWrapper=__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].a(_templateObject,function(props){return props.theme.colors[props.background];},function(props){return props.margin?props.margin:'30px 0';},function(props){return props.borderColor?props.theme.colors[props.borderColor]:'none';},function(props){return props.width?props.width:'auto';});var ButtonLabel=__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].div(_templateObject2,function(props){return props.theme.colors[props.color];},function(props){return props.size?props.size:'13px';},function(props){return props.isTitleNarrowMedium?''+props.theme.fontSets.narrowMedium:''+props.theme.fontSets.narrowRegular;});

/***/ }),

/***/ 264:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ResultWrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ResultLabel; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(53);
var _templateObject=_taggedTemplateLiteral(['\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-evenly;\n  ',';\n  ',';\n'],['\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-evenly;\n  ',';\n  ',';\n']),_templateObject2=_taggedTemplateLiteral(['\n    flex-direction: row !important;\n  '],['\n    flex-direction: row !important;\n  ']),_templateObject3=_taggedTemplateLiteral(['\n    flex-direction: column !important;\n  '],['\n    flex-direction: column !important;\n  ']),_templateObject4=_taggedTemplateLiteral(['\n  color: ',';\n  font-size: 16px;\n  margin: 3px 7px;\n  ',';\n  ',';\n  ','{\n    font-size: 15px; \n  }\n  ',';\n  ',';\n'],['\n  color: ',';\n  font-size: 16px;\n  margin: 3px 7px;\n  ',';\n  ',';\n  ','{\n    font-size: 15px; \n  }\n  ',';\n  ',';\n']),_templateObject5=_taggedTemplateLiteral([' \n    font-family: ',';\n  '],[' \n    font-family: ',';\n  ']),_templateObject6=_taggedTemplateLiteral([' \n    font-size: ',' !important;\n  '],[' \n    font-size: ',' !important;\n  ']),_templateObject7=_taggedTemplateLiteral(['\n     margin: ',';\n  '],['\n     margin: ',';\n  ']),_templateObject8=_taggedTemplateLiteral(['\n    font-size: 15px;\n'],['\n    font-size: 15px;\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var ResultWrapper=__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].div(_templateObject,function(props){return props.isFav&&Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* css */])(_templateObject2);},function(props){return props.isCorr&&Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* css */])(_templateObject3);});var ResultLabel=__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].div(_templateObject4,function(props){return props.theme.colors[props.color];},function(props){return props.font&&Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* css */])(_templateObject5,props.theme.fontSets[props.font]);},function(props){return props.size&&Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* css */])(_templateObject6,props.size);},function(props){return props.theme.mediaQueries.tablet_big_down_team_next_widget;},function(props){return props.customMargin&&Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* css */])(_templateObject7,props.customMargin);},function(props){return props.isMobile&&Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* css */])(_templateObject8);});

/***/ }),

/***/ 310:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_grid_system__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_grid_system___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_grid_system__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_rcs_gaz_mc_core_FE__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_rcs_gaz_mc_core_FE___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__common_rcs_gaz_mc_core_FE__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_TeamLabel__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__TimeResults_Result__ = __webpack_require__(256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__styles__ = __webpack_require__(311);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_configManager_configManager__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__shared_Label__ = __webpack_require__(199);
var CalendarRow=function CalendarRow(_ref){var matchRow=_ref.matchRow,dictionary=_ref.dictionary,competitionId=_ref.competitionId,newspaper=_ref.newspaper,isGazzanet=_ref.isGazzanet;var isHomeWinner=function isHomeWinner(){return Number(matchRow.getIn(['homeTeam','score']))>Number(matchRow.getIn(['awayTeam','score']))&&matchRow.get('status')!=='LIVE';};var isAwayWinner=function isAwayWinner(){return Number(matchRow.getIn(['homeTeam','score']))<Number(matchRow.getIn(['awayTeam','score']))&&matchRow.get('status')!=='LIVE';};//const isLive = () => matchRow.status === 'LIVE';
var classLink=function classLink(){var homeCode=matchRow.getIn(['homeTeam','teamCode']);var awayCode=matchRow.getIn(['awayTeam','teamCode']);var returnedClass='';if(homeCode&&awayCode&&homeCode.length<3&&awayCode.length<3){returnedClass='no-event';}if(homeCode&&awayCode&&Number(homeCode[homeCode.length-1])&&Number(awayCode[awayCode.length-1])){returnedClass='no-event';}return returnedClass;};var formatDate=function formatDate(datePassed){var dateJs=new Date(datePassed);var day=('0'+dateJs.getDate().toLocaleString('it-IT',{timeZone:'Europe/Rome'})).slice(-2);var month=('0'+(Number(dateJs.getMonth().toLocaleString('it-IT',{timeZone:'Europe/Rome'}))+1)).slice(-2);var year=dateJs.getFullYear().toLocaleString().slice(3,5);return day+'/'+month+'/'+year;};var formatHour=function formatHour(datePassed){var dateJs=new Date(datePassed);var hours=('0'+dateJs.getHours().toLocaleString('it-IT',{timeZone:'Europe/Rome'})).slice(-2);var minutes=('0'+dateJs.getMinutes().toLocaleString('it-IT',{timeZone:'Europe/Rome'})).slice(-2);return hours+':'+minutes;};var imagesURL=__WEBPACK_IMPORTED_MODULE_7__common_configManager_configManager__["a" /* default */].getFootballTeams('min');var awayResPen=matchRow.getIn(['awayTeam','starData'])&&matchRow.getIn(['awayTeam','starData','shootOuts'])&&matchRow.getIn(['awayTeam','starData','shootOuts','score'])?matchRow.getIn(['awayTeam','starData','shootOuts','score']):0;var homeResPen=matchRow.getIn(['homeTeam','starData'])&&matchRow.getIn(['homeTeam','starData','shootOuts'])&&matchRow.getIn(['homeTeam','starData','shootOuts','score'])?matchRow.getIn(['homeTeam','starData','shootOuts','score']):0;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__styles__["a" /* MatchRowWrapper */],{disableLink:isGazzanet,className:classLink(),href:Object(__WEBPACK_IMPORTED_MODULE_3__common_rcs_gaz_mc_core_FE__["prettyMatchUrl"])(matchRow.getIn(['homeTeam','teamName']),matchRow.getIn(['awayTeam','teamName']),matchRow.get('matchId'),1,competitionId,newspaper)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_grid_system__["Row"],{style:{width:'100%',marginRight:'0',marginLeft:'0',alignItems:'center',justifyContent:'center'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_grid_system__["Col"],{md:12,style:{paddingLeft:0,paddingRight:0,display:'flex',justifyContent:'center'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__shared_Label__["a" /* default */],{label:formatDate(matchRow.get('date')),size:0.75,isTitleNarrowMedium:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_grid_system__["Row"],{style:{width:'100%',marginRight:'0',marginLeft:'0',alignItems:'center'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_grid_system__["Col"],{sm:4.9,md:5,style:{paddingLeft:0,paddingRight:0,display:'flex',justifyContent:'center'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_grid_system__["Col"],{sm:4.5,style:{paddingLeft:0,paddingRight:0,display:'flex',justifyContent:'flex-end'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__shared_TeamLabel__["a" /* default */],{color:'black',image:''+imagesURL+matchRow.getIn(['homeTeam','teamId'])+'.png',marginLeft:0.5,font:isHomeWinner()?'narrowMedium':'narrowRegular',size:16})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_grid_system__["Col"],{sm:7.5,style:{paddingLeft:0,paddingRight:0,display:'flex',justifyContent:'flex-start'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__shared_Label__["a" /* default */],{label:matchRow.getIn(['homeTeam','teamName'])!=='TBC'?matchRow.getIn(['homeTeam','teamName']):'- -',color:'black',font:isHomeWinner()?'narrowMedium':'narrowRegular',size:0.9})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_grid_system__["Col"],{lg:2,md:2,sm:2,xs:2,style:{paddingLeft:0,paddingRight:0}},matchRow.get('status')==='LIVE'||matchRow.get('status')==='FULL'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__TimeResults_Result__["a" /* default */],{awayRes:matchRow.getIn(['awayTeam','score']),homeRes:matchRow.getIn(['homeTeam','score']),awayPenRes:awayResPen,homePenRes:homeResPen,status:matchRow.get('status')}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{display:'flex',justifyContent:'center'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__shared_Label__["a" /* default */],{label:formatHour(matchRow.get('date'))}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_grid_system__["Col"],{md:5,sm:4.9,style:{paddingLeft:0,paddingRight:0,display:'flex',justifyContent:'center'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_grid_system__["Col"],{sm:4.5,style:{paddingLeft:0,paddingRight:0,display:'flex',justifyContent:'flex-end'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__shared_TeamLabel__["a" /* default */],{color:'black',image:''+imagesURL+matchRow.getIn(['awayTeam','teamId'])+'.png',marginLeft:0.5,font:isHomeWinner()?'narrowMedium':'narrowRegular',size:16})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_grid_system__["Col"],{sm:7.5,style:{paddingLeft:0,paddingRight:0,display:'flex',justifyContent:'flex-start'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__shared_Label__["a" /* default */],{label:matchRow.getIn(['awayTeam','teamName'])!=='TBC'?matchRow.getIn(['awayTeam','teamName']):'- -',color:'black',font:isAwayWinner()?'narrowMedium':'narrowRegular',size:0.9}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_grid_system__["Row"],{style:{width:'100%',marginRight:'0',marginLeft:'0',alignItems:'center',justifyContent:'center'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_grid_system__["Col"],{md:12,style:{paddingLeft:0,paddingRight:0,display:'flex',justifyContent:'center',overflow:'visible'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__shared_Label__["a" /* default */],{label:''+(dictionary.competitionTable.competitionName[competitionId]||'Altre competizioni '),margin:'0px 5px 0px 0px',size:0.8}))));};CalendarRow.propTypes={matchRow:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,dictionary:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,competitionId:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,newspaper:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,isGazzanet:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool};/* harmony default export */ __webpack_exports__["a"] = (CalendarRow);

/***/ }),

/***/ 311:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MatchRowWrapper; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(53);
var _templateObject=_taggedTemplateLiteral(['\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  border-radius: 0.1em;\n  min-height: 4em;\n  width: 100%;\n  padding: 0.5em 0;\n  //margin: ',';\n  border-bottom: 1px solid ',';\n  background: ',';\n  text-decoration: none;\n  &.no-event{\n    pointer-events: none;\n    .icon-matchcenter-right-arrow{\n      display: none;\n    }\n  }\n  ','\n'],['\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  border-radius: 0.1em;\n  min-height: 4em;\n  width: 100%;\n  padding: 0.5em 0;\n  //margin: ',';\n  border-bottom: 1px solid ',';\n  background: ',';\n  text-decoration: none;\n  &.no-event{\n    pointer-events: none;\n    .icon-matchcenter-right-arrow{\n      display: none;\n    }\n  }\n  ','\n']),_templateObject2=_taggedTemplateLiteral(['\n    pointer-events: none !important;\n    cursor: default !important;\n  '],['\n    pointer-events: none !important;\n    cursor: default !important;\n  ']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var MatchRowWrapper=__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].a(_templateObject,function(props){return props.isHighlight?'0px':'0 auto 0.4em';},function(props){return props.theme.colors.gray;},function(props){return props.isLastmatch?props.theme.colors.teamCalendarLastColor:'initial';},function(props){return props.disableLink&&Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* css */])(_templateObject2);});

/***/ }),

/***/ 392:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TeamCalendarWidgetWrapper; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(53);
var _templateObject=_taggedTemplateLiteral(['\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  background: ',';\n'],['\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  background: ',';\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var TeamCalendarWidgetWrapper=__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].div(_templateObject,function(props){return props.theme.colors.mainColor;});

/***/ })

});


// WEBPACK FOOTER //
// 20241119095807206.extra/chunks/23.c61bb4b2.min.js